var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52184 5.36V9.1336C2.52184 10.0555 2.52184 10.5165 2.82661 10.8029C3.13138 11.0893 3.5304 11.0893 4.51145 11.0893H7.81432C8.79536 11.0893 9.1962 11.0893 9.50098 10.8029C9.80576 10.5165 9.80576 10.0555 9.80576 9.1336V5.36M1.09482 4.34556L2.28879 2.32956C2.40978 2.12528 2.62958 2 2.867 2H9.76533C10.0216 2 10.2556 2.14575 10.3685 2.37578L11.3585 4.39178C11.5778 4.8383 11.2528 5.36 10.7554 5.36H1.67303C1.1524 5.36 0.82952 4.79352 1.09482 4.34556Z",
    stroke: "#111D31",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.8fa8b1da435a9080c03c9883b263a241.svg";
export { ForwardRef as ReactComponent };